/** @jsx jsx */
import { jsx } from "theme-ui";
import React, { Fragment } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { ImageProps } from "./Interfaces";

// Render inline SVG with fallback non-svg images
const RockitImage: React.FC<ImageProps> = ({
  svg,
  gatsbyImageData,
  loading,
  file,
  alt,
  width,
  height,
  styles,
  className,
  objectFit,
  objectPosition,
}) => {
  width = width ? width : "100%";
  height = height ? height : "100%";

  if (file?.contentType === "image/svg+xml") {
    if (svg && svg.content) {
      // Inlined SVGs
      const content = (svg.originalContent || svg.content as string).replace(
        "<svg ",
        `<svg style="display:block;" fill="currentColor" ${
          width === "ignore" ? "" : `width="${width}"`
        } height="${height}"`
      );

      return (
        <i
          sx={{ ...styles }}
          className={className}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      );
    }

    // SVGs that can/should not be inlined
    return <img src={file.url} alt={alt} />;
  }

  // Non SVG images
  return (
    <GatsbyImage
      loading={loading || "lazy"}
      alt={alt}
      image={gatsbyImageData}
      className={className}
      objectFit={objectFit || "cover"}
      objectPosition={objectPosition || "center center"}
    />
  );
};

export default RockitImage;

/* <GatsbyImage
      fixed={fixed}
      fluid={fluid}
      alt={alt}
      className={className}
      imgStyle={imageStyle}
   />*/
